export const environment = {
	production: false,
	// baseUrl: 'http://localhost:3000',
	baseUrl: 'https://api.ganjastan.co.uk',
};
